import React from "react";
import { useNavigate } from "react-router-dom";
import { storageData } from "services/Services";

const FooterSection = () => {
  const navigate = useNavigate();

  // Removes changes for extra storage in local storage & navigates to home page
  const removeItems = () => {
    storageData.removeItem("drivers");
    storageData.removeItem("newDrivers");
    storageData.removeItem("members");
    storageData.removeItem("newMembers");
    storageData.removeItem("effectiveDate");
    storageData.removeItem("currResidence");
    storageData.removeItem("vehicleInfo");
    storageData.removeItem("PendingAddress");
    storageData.removeItem("PendingAddedDrivers");
    storageData.removeItem("PendingAddedHhms");
    storageData.removeItem("PendingRemovedDrivers");
    storageData.removeItem("PendingRemovedHhms");
    storageData.removeItem("PendingAddedVehicles");
    storageData.removeItem("PendingRemovedVehicles");
    storageData.removeItem("newResidenceData");
    storageData.removeItem("householdData");
    storageData.removeItem("additionalData");
    storageData.removeItem("driverAssignmentData");
    storageData.removeItem("summaryChanges");
    storageData.removeItem("updatedAddedDrivers");
    storageData.removeItem("AddressChangeConfirmationNumber");
    storageData.removeItem("updateHouseholdData");
    storageData.removeItem("householdAdditionalData");
    storageData.removeItem("householdSummaryChanges");
    storageData.removeItem("HouseholdChangeConfirmationNumber");
    storageData.removeItem("updateVehicleData");
    storageData.removeItem("updateDriverAssignmentData");
    storageData.removeItem("newVehicles");
    storageData.removeItem("dbVehicles");
    storageData.removeItem("vehicleSummaryChanges");
    storageData.removeItem("VehicleChangeConfirmationNumber");
    storageData.removeItem("storedDrivers");
    storageData.removeItem("storedHouseholdMembers");
    storageData.removeItem("storedVehicles");
    storageData.removeItem("LeasingList");
    storageData.removeItem("FinanceCompanyList");
    storageData.removeItem("LeasingListGW");
    storageData.removeItem("FinanceListGW");
    storageData.removeItem("VehicleChangeClass");
    storageData.removeItem("HouseholdChangeClass");
    storageData.removeItem("AddressChangeClass");
    storageData.removeItem("VehicleChangeID");
    storageData.removeItem("HouseholdChangeID");
    storageData.removeItem("AddressChangeID");
    storageData.removeItem("AddVehicleClass");
    storageData.removeItem("RemoveVehicleClass");
    storageData.removeItem("ReplaceVehicleClass");
    storageData.removeItem("responseData");
    storageData.removeItem("updateVehicleData");
    storageData.removeItem("updateDriverAssignmentData");
    storageData.removeItem("newVehicles");
    storageData.removeItem("dbVehicles");
    storageData.removeItem("vehicleSummaryChanges");
    storageData.removeItem("HouseholdChangeConfirmationNumber");
    storageData.removeItem("storedDrivers");
    storageData.removeItem("storedHouseholdMembers");
    storageData.removeItem("storedVehicles");
    storageData.removeItem("PendingAddedVehicles");
    storageData.removeItem("PendingRemovedVehicles");
    storageData.removeItem("PendingAddedDrivers");
    storageData.removeItem("PendingAddedHhms");
    storageData.removeItem("PendingRemovedDrivers");
    storageData.removeItem("PendingRemovedHhms");
    storageData.removeItem("PendingAddress");
    storageData.removeItem("vehicleInfo");
    storageData.removeItem("currResidence");
    storageData.removeItem("HouseholdChangeClass");

    navigate("/home");
  };

  return (
    <div className="footer">
      <div className="text-center mb-4">
        <input
          type={"button"}
          className="btn btn-primary-grad"
          value={"Return to My Account Home"}
          onClick={removeItems}
        />
      </div>
    </div>
  );
};

export default FooterSection;
